import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';



const ErrorState = ({
  message = 'There was an error loading the content.',
  onRetry,
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-center justify-center p-6 text-center ${className}`}>
      <div className="mb-4 text-red-500 animate-appear">
        <AlertCircle size={48} />
      </div>
      <h3 className="text-lg font-medium text-gray-800 mb-2">Unable to load content</h3>
      <p className="text-gray-600 mb-4 max-w-md">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-dark transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary/50"
        >
          <RefreshCw size={16} className="animate-spin-slow" />
          <span>Try Again</span>
        </button>
      )}
    </div>
  );
};

export default ErrorState;

